module.exports = __webpack_public_path__ + "static/img/smiled.7358e1b9.svg";